import { render, staticRenderFns } from "./mapWorld.vue?vue&type=template&id=1c1f8531&scoped=true&"
import script from "./mapWorld.vue?vue&type=script&lang=js&"
export * from "./mapWorld.vue?vue&type=script&lang=js&"
import style0 from "./mapWorld.vue?vue&type=style&index=0&id=1c1f8531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f8531",
  null
  
)

export default component.exports